const chapter1QuickTourAuction = {
  auctionLights: ['green', 'blue'],
  autosell: true,
  buyerInfo: null,
  canBid: true,
  canEditPersistentProxy: false,
  canFinalize: false,
  canMakeOffer: false,
  canNegotiate: false,
  canProxyBid: false,
  canPurchaseNow: null,
  cylinders: 8,
  dealershipClaims: [],
  dealershipMemberBids: [],
  doors: 4,
  drivetrain: '4WD',
  endTime: Math.round((new Date(new Date().getTime() + (20 * 60 * 1000)).getTime()) / 1000),
  finalized: false,
  floorPrice: 45800,
  hasViewedDetails: true,
  highBid: 42850,
  id: 1,
  isMemberOfSellingDealership: false,
  isMemberOfTopBiddingDealership: false,
  isOnWatchList: false,
  isPrimarySeller: false,
  isPrimaryTopBidder: false,
  isPrivate: false,
  isSealedBid: false,
  make: 'Chevrolet',
  model: 'Silverado 1500',
  myAuctionClaim: null,
  negotiationInfo: null,
  odometer: 17758,
  participant: false,
  pendingOffer: null,
  pickupCity: 'Pikeville',
  pickupRegion: 'KY',
  primaryImage: {
    acvLarge: 'https://cdn.acvauctions.com/vehicle_photos/1000x1000/cab41bec7ef84a9a9cae3738ae3daf03.jpg',
    acvMedium: 'https://cdn.acvauctions.com/vehicle_photos/600x600/cab41bec7ef84a9a9cae3738ae3daf03.jpg',
    acvThumbnail: 'https://cdn.acvauctions.com/vehicle_photos/300x300/cab41bec7ef84a9a9cae3738ae3daf03.jpg',
  },
  privateAuctionMakeOfferEndTime: null,
  privateAuctionPhase: null,
  privateLaneId: null,
  proxyBid: null,
  proxyBidInterval: 50,
  purchaseNowEnabled: false,
  savedAuctionId: 1887927,
  sellerBadgeInfo: null,
  sellerStatus: {
    featuredSeller: null,
    topSeller: null,
  },
  showReserve: false,
  previewShowStartPrice: false,
  startPrice: 41500,
  startTime: new Date().getTime(),
  status: 'active',
  statusPills: [],
  trim: 'LTZ',
  vin: '3GCUKSEC0JG497431',
  year: 2018,
  includeInCollections: [{ fetchMethod: 'getFiltersAuctionsBuyingActive', index: 0 }],
};

const chapter1MyNegotiationsAuction = {
  auctionLights: ['green'],
  autosell: true,
  buyerInfo: null,
  canBid: false,
  canEditPersistentProxy: false,
  canFinalize: false,
  canMakeOffer: false,
  canNegotiate: true,
  canProxyBid: false,
  canPurchaseNow: null,
  cylinders: 4,
  dealershipClaims: [],
  dealershipMemberBids: [],
  doors: 4,
  drivetrain: 'AWD',
  endTime: 1632337590,
  finalized: false,
  floorPrice: 28750,
  hasViewedDetails: true,
  highBid: 27850,
  id: 3584276,
  isMemberOfSellingDealership: false,
  isMemberOfTopBiddingDealership: true,
  isOnWatchList: false,
  isPrimarySeller: false,
  isPrimaryTopBidder: true,
  isPrivate: false,
  isSealedBid: false,
  make: 'BMW',
  model: 'X3',
  myAuctionClaim: null,
  negotiationInfo: {
    lastOfferUserId: 0,
    lastOffer: 27600,
    ourOffer: 27600,
    theirOffer: 28200,
  },
  odometer: 9020,
  participant: true,
  pendingOffer: null,
  pickupCity: 'East Brunswick',
  pickupRegion: 'NJ',
  primaryImage: {
    acvLarge: 'https://cdn.acvauctions.com/vehicle_photos/1000x1000/a6101371d3334759852380b972e4e417.jpg',
    acvMedium: 'https://cdn.acvauctions.com/vehicle_photos/600x600/a6101371d3334759852380b972e4e417.jpg',
    acvThumbnail: 'https://cdn.acvauctions.com/vehicle_photos/300x300/a6101371d3334759852380b972e4e417.jpg',
  },
  privateAuctionMakeOfferEndTime: null,
  privateAuctionPhase: null,
  privateLaneId: null,
  proxyBid: null,
  proxyBidInterval: 50,
  purchaseNowEnabled: false,
  savedAuctionId: 1891682,
  sellerBadgeInfo: null,
  sellerStatus: {
    featuredSeller: null,
    topSeller: null,
  },
  showReserve: false,
  previewShowStartPrice: false,
  startPrice: 25400,
  startTime: 1632337590,
  status: 'counter_sent',
  statusPills: ['received_last_negotiation'],
  trim: 'XDrive28i',
  vin: '5UXWX9C55G0D70762',
  year: 2016,
  includeInCollections: [{ fetchMethod: 'getMyNegotiations', index: 0 }],
};

const chapter1ActiveAuctionTourAuction = {
  ...chapter1QuickTourAuction,
  cylinders: 4,
  drivetrain: 'AWD',
  floorPrice: 25000,
  highBid: 24900,
  id: 3585085,
  make: 'Chevrolet',
  model: 'Equinox',
  odometer: 15274,
  pickupCity: 'Vermilion',
  pickupRegion: 'OH',
  primaryImage: {
    acvLarge: 'https://cdn.acvauctions.com/vehicle_photos/1000x1000/93565589ba88477a8d24b62ae34d3b64.jpg',
    acvMedium: 'https://cdn.acvauctions.com/vehicle_photos/600x600/93565589ba88477a8d24b62ae34d3b64.jpg',
    acvThumbnail: 'https://cdn.acvauctions.com/vehicle_photos/300x300/93565589ba88477a8d24b62ae34d3b64.jpg',
  },
  savedAuctionId: 1895714,
  startPrice: 21900,
  statusPills: ['high_bidder'],
  trim: 'LT',
  vin: '3GNAXUEV5KL323744',
  year: 2019,
  endTime: Math.round((new Date(new Date().getTime() + (10 * 60 * 1000)).getTime()) / 1000),
  includeInCollections: [{ fetchMethod: 'getMyActiveAuctions', index: 0 }],
};

const chapter1WatchlistTourAuctions = [
  {
    auctionLights: ['green', 'blue'],
    includeInCollections: [{ fetchMethod: 'getWatchList', index: 0 }],
    autosell: true,
    buyerInfo: null,
    canBid: false,
    canEditPersistentProxy: false,
    canFinalize: false,
    canMakeOffer: false,
    canNegotiate: false,
    canProxyBid: false,
    canPurchaseNow: null,
    cylinders: null,
    dealershipClaims: [],
    dealershipMemberBids: [],
    doors: null,
    drivetrain: 'FWD',
    endTime: 1608246315,
    finalized: false,
    floorPrice: 11250,
    hasViewedDetails: true,
    highBid: null,
    id: 2363923,
    isMemberOfSellingDealership: false,
    isMemberOfTopBiddingDealership: false,
    isOnWatchList: true,
    isPrimarySeller: false,
    isPrimaryTopBidder: false,
    isPrivate: false,
    isSealedBid: false,
    make: 'Jeep',
    model: 'Cherokee',
    myAuctionClaim: null,
    negotiationInfo: null,
    odometer: 64300,
    participant: false,
    pendingOffer: null,
    pickupCity: 'Miami',
    pickupRegion: 'FL',
    primaryImage: {
      acvLarge: 'https://cdn.acvauctions.com/vehicle_photos/1000x1000/ef0f539ec3f8447e8281d95e7c9c9996.jpg',
      acvMedium: 'https://cdn.acvauctions.com/vehicle_photos/600x600/ef0f539ec3f8447e8281d95e7c9c9996.jpg',
      acvThumbnail: 'https://cdn.acvauctions.com/vehicle_photos/300x300/ef0f539ec3f8447e8281d95e7c9c9996.jpg',
    },
    privateAuctionMakeOfferEndTime: null,
    privateAuctionPhase: null,
    privateLaneId: null,
    proxyBid: null,
    proxyBidInterval: 50,
    purchaseNowEnabled: false,
    savedAuctionId: 1224590,
    sellerBadgeInfo: null,
    sellerStatus: {
      featuredSeller: null,
      topSeller: null,
    },
    showReserve: false,
    previewShowStartPrice: false,
    startPrice: 9000,
    startTime: 1608245114,
    status: 'ended_nobid',
    statusPills: [],
    trim: 'Sport',
    vin: '1C4PJLAB5EW112259',
    year: 2014,
  }, {
    auctionLights: ['green', 'blue'],
    includeInCollections: [{ fetchMethod: 'getWatchList', index: 0 }],
    autosell: true,
    buyerInfo: null,
    canBid: false,
    canEditPersistentProxy: false,
    canFinalize: false,
    canMakeOffer: false,
    canNegotiate: false,
    canProxyBid: false,
    canPurchaseNow: null,
    cylinders: 6,
    dealershipClaims: [],
    dealershipMemberBids: [],
    doors: 4,
    drivetrain: '4WD',
    endTime: 1632515656,
    finalized: true,
    floorPrice: 36000,
    hasViewedDetails: false,
    highBid: 36000,
    id: 3586796,
    isMemberOfSellingDealership: false,
    isMemberOfTopBiddingDealership: false,
    isOnWatchList: true,
    isPrimarySeller: false,
    isPrimaryTopBidder: false,
    isPrivate: false,
    isSealedBid: false,
    make: 'Toyota',
    model: 'Tacoma',
    myAuctionClaim: null,
    negotiationInfo: null,
    odometer: 42834,
    participant: false,
    pendingOffer: null,
    pickupCity: 'Vienna',
    pickupRegion: 'VA',
    primaryImage: {
      acvLarge: 'https://cdn.acvauctions.com/vehicle_photos/1000x1000/d4601e3ceb03429c986ac2c90e6d0d6b.jpg',
      acvMedium: 'https://cdn.acvauctions.com/vehicle_photos/600x600/d4601e3ceb03429c986ac2c90e6d0d6b.jpg',
      acvThumbnail: 'https://cdn.acvauctions.com/vehicle_photos/300x300/d4601e3ceb03429c986ac2c90e6d0d6b.jpg',
    },
    privateAuctionMakeOfferEndTime: null,
    privateAuctionPhase: null,
    privateLaneId: null,
    proxyBid: null,
    proxyBidInterval: 50,
    purchaseNowEnabled: false,
    savedAuctionId: 1897294,
    sellerBadgeInfo: null,
    sellerStatus: {
      featuredSeller: null,
      topSeller: null,
    },
    showReserve: false,
    previewShowStartPrice: false,
    startPrice: 32200,
    startTime: 1632515656,
    status: 'ended_unwound',
    statusPills: [],
    trim: 'TRD Sport',
    vin: '3TMCZ5AN9HM114937',
    year: 2017,
  }, {
    auctionLights: ['green', 'blue'],
    includeInCollections: [{ fetchMethod: 'getWatchList', index: 0 }],
    autosell: true,
    buyerInfo: null,
    canBid: false,
    canEditPersistentProxy: false,
    canFinalize: false,
    canMakeOffer: false,
    canNegotiate: false,
    canProxyBid: false,
    canPurchaseNow: null,
    cylinders: 6,
    dealershipClaims: [],
    dealershipMemberBids: [],
    doors: 4,
    drivetrain: 'FWD',
    endTime: 1632345449,
    finalized: true,
    floorPrice: 17900,
    hasViewedDetails: false,
    highBid: 17200,
    id: 3586659,
    isMemberOfSellingDealership: false,
    isMemberOfTopBiddingDealership: false,
    isOnWatchList: true,
    isPrimarySeller: false,
    isPrimaryTopBidder: false,
    isPrivate: false,
    isSealedBid: false,
    make: 'Ford',
    model: 'Edge',
    myAuctionClaim: null,
    negotiationInfo: null,
    odometer: 60452,
    participant: false,
    pendingOffer: null,
    pickupCity: 'Greenville',
    pickupRegion: 'SC',
    primaryImage: {
      acvLarge: 'https://cdn.acvauctions.com/vehicle_photos/1000x1000/94a43d5f04544a8eb7fc28df1a7bf897.jpg',
      acvMedium: 'https://cdn.acvauctions.com/vehicle_photos/600x600/94a43d5f04544a8eb7fc28df1a7bf897.jpg',
      acvThumbnail: 'https://cdn.acvauctions.com/vehicle_photos/300x300/94a43d5f04544a8eb7fc28df1a7bf897.jpg',
    },
    privateAuctionMakeOfferEndTime: null,
    privateAuctionPhase: null,
    privateLaneId: null,
    proxyBid: null,
    proxyBidInterval: 50,
    purchaseNowEnabled: false,
    savedAuctionId: 1876216,
    sellerBadgeInfo: null,
    sellerStatus: {
      featuredSeller: null,
      topSeller: null,
    },
    showReserve: false,
    previewShowStartPrice: false,
    startPrice: 15200,
    startTime: 1632344083,
    status: 'counter_accepted',
    statusPills: [],
    trim: 'SEL',
    vin: '2FMPK3J87HBB50661',
    year: 2017,
  },
];
export {
  chapter1QuickTourAuction,
  chapter1MyNegotiationsAuction,
  chapter1ActiveAuctionTourAuction,
  chapter1WatchlistTourAuctions,
};
